// extracted by mini-css-extract-plugin
module.exports = {"nameSummary":"style-module_nameSummary__3GyDx_ySCvFquUcfWGO0le","slugSummary":"style-module_slugSummary__1rP8QOLjczoUlasWt5BBlV"};